<template>
    <!-- <div>{{ tariffsBlock }}</div> -->
    <div class="block-container">
        <div
            class="card"
            v-for="tariff in tariffsBlock"
            :key="tariff.title"
        >
            <div class="button_container">
                <button
                    class="openInfo"
                    @click="toggleInformation(tariff)"
                >
                    {{ isOpen[tariff.type] ? '-' : '+' }}
                </button>
            </div>
            <div class="top-content">
                <div
                    class="title"
                    v-if="typeof tariff.title === 'string'"
                >
                    <h3>
                        {{ tariff.title }}
                    </h3>
                    <span :class="`icon-${tariff.title.toLowerCase()}`" :style="{color: tariff.color}" />
                </div>
                <template v-else>
                    <div
                        class="title"
                        style="margin-left: 10px"
                    >
                        <template
                            v-for="(_, index) in tariff.title"
                            :key="index"
                        >
                            <h3>
                                {{ tariff.title[index] }}
                            </h3>
                            <span :class="`icon-${tariff.title[index].toLowerCase()}`" />
                            <span
                                v-if="tariff.title.length > index + 1"
                                class="separator"
                            >{{ "+ " }}</span>
                        </template>
                    </div>
                </template>
                <!-- PRICE ON CARD -->
                <div class="information">
                    <p class="price">$ {{ tariff.price }}</p>
                    <p class="description">{{ $t(tariff.description) }}</p>
                </div>
            </div>
            <!-- INFORMATION LIST CONTENT -->

            <ul
                class="content"
                v-if="isOpen[tariff.type] || documentWidth > 640"
            >
                <li
                    v-for="(list, index) in $tm(tariff.list)"
                    :key="index"
                    class="content-row"
                    :style="{ borderTopColor: tariff.secondColor }"
                >
                    <b-icon-check-circle-fill
                        class="icon"
                        :style="{ color: tariff.color }"
                    />
                    <span> {{ list }}</span>
                </li>
            </ul>
        </div>
    </div>
</template>

<script setup>
import { ref, computed, onMounted, onUnmounted } from "vue";
import MessengerIconBase from "@/components/Icons/MessengerIconBase.vue";
import tariffsBlockConfig from "./configs/tariffsBlockConfig.js";

const { tariffsBlock } = tariffsBlockConfig();

const isOpen = ref(Object.fromEntries(tariffsBlock.map(tariff => [tariff.type, false])));

const documentWidth = ref(document.documentElement.clientWidth);


onMounted(() => {
    window.addEventListener("resize", handleWindowResize);
});

const toggleInformation = (tariff) => {
    if (documentWidth.value > 640) {
        isOpen.value[tariff.type] = false;
    } else {
        isOpen.value[tariff.type] = !isOpen.value[tariff.type];
    }
};

const handleWindowResize = () => {
    documentWidth.value = document.documentElement.clientWidth;

    tariffsBlock.forEach((tariff) => {
        if (documentWidth.value > 640) {
            isOpen[tariff.type] = false;
        }
    });
};

onUnmounted(() => {
    window.removeEventListener("resize", handleWindowResize);
});
</script>

<style lang="scss" scoped>
.icon-viber {
    font-size: 33px;
    color: #7C509A;
}

.icon-telegram {
    font-size: 39px;
    color: #27A6E5;
}

.icon-whatsapp {
    font-size: 24px;
    margin-left: 5px;
}

.content-row {
    display: flex;
    justify-content: left;
    align-items: center;
}

.block-container {
    display: flex;
    justify-content: space-between;
    gap: 25px;
}

.card {
    background: var(--block-color);
    max-width: 420px;
    min-width: 280px;
    border-radius: 10px;
    display: flex;
    align-items: center;
    padding: 30px 25px;
    border: none;

    .top-content {
        width: 100%;

        .title {
            height: 39px;
            margin-bottom: -3px;
            display: flex;
            align-items: center;
            justify-content: center;
            font-size: var(--title-text);
            font-weight: 700;
        }

        h3 {
            font-weight: 700;
            font-family: Gilroy;
            color: var(--text-color);
            text-transform: uppercase;
        }

        .information {
            display: flex;
            justify-content: center;
            align-items: baseline;
            flex-wrap: wrap;

            @media screen and (min-width: 1220px) and (max-width: 1540px) {
                align-items: center;
                flex-direction: column;
            }

            @media screen and (min-width: 1025px) and (max-width: 1120px) {
                align-items: center;
                flex-direction: column;
            }
        }

        .price {
            font-family: Gilroy;
            font-size: 45px;
            font-weight: 600;
            color: var(--general-color);
            margin-right: 10px;
        }

        .description {
            font-family: Gilroy;
            font-size: 14px;
            font-weight: 500;
            color: var(--text-color);
        }
    }

    ul.content {
        width: 100%;

        li {
            padding: 0 10px;
            font-family: Gilroy;
            font-size: 14px;
            font-weight: 500;
            color: var(--text-color);
            border-top: 2px solid var(--general-color);
            padding: 10px 5px 15px;

            svg {
                color: var(--general-color);
                font-size: 20px;
                width: fit-content;
                margin-right: 10px;
            }

            &:first-child {
                border-top: 0px;
            }
        }
    }
}

.button_container {
    display: none;
}

.separator {
    margin-right: 5px;
}

@media screen and (max-width: 480px) {
    .block-container {
        flex-direction: column;
        width: 100%;
    }

    .card {
        padding: 30px 15px;
        width: 100%;

        .top-content {
            display: flex;
            flex-direction: column;

            .price {
                width: 100%;
                margin-right: 0;
                justify-content: center;
                display: flex;
            }

            .description {
                width: 100%;
                text-align: center;
            }

            .information {
                flex-direction: column;
            }
        }

        ul.content {
            margin-top: 0;
            gap: 0;

            .content-row {
                margin: 0;
            }
        }
    }
}

@media screen and (max-width: 640px) {
    .card {
        width: inherit;
    }

    .openInfo {
        font-size: 25px;
        color: #7A70DF;
    }

    .button_container {
        display: block;
        width: 27px;
        height: 27px;
        background: white;
        border-radius: 7px;
        display: flex;
        justify-content: center;
        align-items: center;
        position: absolute;
        left: 5px;
        top: 5px;
    }
}

@media screen and (max-width: 1024px) {
    .block-container {
        flex-wrap: wrap;
        width: -webkit-fill-available;
        justify-content: center;
    }
}

@media screen and (min-width: 1199px) {
    .card {
        padding: 15px;
        min-width: 240px;
    }
}

@media screen and (max-width: 390px) {
    .card {
        min-width: 245px;
    }
}

</style>
